import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {getLocalizedGiftName} from '../../utils/multilingual';
import open from '../../assets/images/open.png';
import deleteI from '../../assets/images/delete.png';

const Dropdown = ({
  label,
  dark,
  white,
  maxWidth,
  marginRight,
  items,
  callback,
  value,
  ...rest
}) => {
  const {t, i18n} = useTranslation();
  let new_item = [items];

  const [state, setState] = useState({currentItems: items, filterValue: ''});

  useEffect(() => {
    if (value != undefined && value != null) {
      let filterItem = items.filter(e => e.id === value);

      if (filterItem.length > 0) {
        const displayValue = getLocalizedGiftName(filterItem[0]) || filterItem[0].name;
        setState(s => ({
          ...s,
          value: displayValue,
        }));
      }
    }
  }, [value, items]);

  const openFunction = () => {
    setState(s => ({
      ...s,
      openList: !state.openList,
    }));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (state.openList && !event.target.closest('.dropdown-container')) {
        setState(s => ({ ...s, openList: false }));
      }
    };

    if (state.openList) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [state.openList]);

  return (
    <div className="flex flex-col flex-grow dropdown-container">
      <div
        style={{
          overflowY: 'auto',
          position: 'absolute',
          backgroundColor: 'white',
          borderWidth: 1,
          borderColor: '#E1E1E1',
          borderRadius: 5,
          textAlign: 'left',
          height: 200,
          width: 200,
          display: state.openList ? 'block' : 'none',
        }}>
        <div
          style={{
            padding: 10,
            borderBottomWidth: 1,
            borderBottomColor: '#E1E1E1',
            fontWeight: 'bold',
          }}>
          <input
            style={{width: '80%'}}
            placeholder={t('components.dropdown.filter')}
            value={state.filterValue}
            onChange={event => {
              var value = event.target.value;
              var itens = [];
              for (var i = 0; i < items.length; i++) {
                var item = items[i];
                const itemName = getLocalizedGiftName(item) || item.name;
                if (itemName?.toLowerCase().includes(value?.toLowerCase())) {
                  itens.push(item);
                }
              }
              setState(s => ({
                ...s,
                currentItems: itens,
                filterValue: value,
              }));
            }}
          />
          <img
            onClick={() => {
              setState(s => ({
                ...s,
                value: '',
                filterValue: '',
                currentItems: items,
              }));
              // Call callback with null to indicate no selection
              callback(null);
            }}
            src={deleteI}
            alt="?"
            style={{
              width: 15,
              height: 15,
              cursor: 'pointer',
              marginTop: 5,
              float: 'right',
            }}
            title={t('components.dropdown.helpText')}
          />
        </div>
        {state.currentItems &&
          state.currentItems.map((item, key) => (
            <div
              key={key}
              onClick={() => {
                callback(item.id);
                setState(s => ({
                  ...s,
                  value: getLocalizedGiftName(item) || item.name,
                  openList: false,
                }));
              }}
              style={{
                padding: 10,
                borderBottomWidth: 1,
                borderBottomColor: '#E1E1E1',
                cursor: 'pointer',
              }}>
              {getLocalizedGiftName(item) || item.name}
            </div>
          ))}
      </div>
      <p
        className={`${
          dark ? 'text-white' : 'text-black'
        } text-xs uppercase font-light`}>
        {label}
      </p>
      <div
        {...rest}
        className={`${
          dark ? 'bg-trueGray-100' : 'bg-transparent'
        } rounded h-8 my-2 px-2 text-sm ${dark ? 'border-0' : 'border'}`}
        style={{
          backgroundColor: white ? 'white' : 'transparent',
          maxWidth: maxWidth ? maxWidth : undefined,
          marginRight: marginRight,
          paddingTop: 5,
          textAlign: 'left',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <div
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
            paddingRight: '8px'
          }}
          title={state.value || ''}>
          {state.value ? state.value : ''}
        </div>
        <img
          onClick={() => openFunction()}
          src={open}
          alt="?"
          style={{
            width: 15,
            height: 15,
            cursor: 'pointer',
            flexShrink: 0,
          }}
          title={t('components.dropdown.helpText')}
        />
      </div>
    </div>
  );
};

export default Dropdown;
